import React, { memo, useState, useEffect } from "react";
import { motion } from "framer-motion";
import Logo from "../../img/logo.svg";
import anim from "../../utils/anim";

import "./brand-bubbles.css";

const BrandBubble = memo(
	({
		center = false,
		imgSrc = "",
		dataArray,
		index,
		zindex,
		scale = 1,
		right = false,
		left = false,
		top = false,
		noAnim = false,
		className = "",
		...props
	}) => {
		const [, setDisplay] = useState(true);
		useEffect(() => {
			if (center || index < dataArray.length) {
				return;
			}
			setDisplay(false);
		}, [center, index, dataArray, setDisplay]);
		return (
			<motion.img
				src={
					center
						? imgSrc
						: index < dataArray.length
						? dataArray[index].logo_url
						: Logo
				}
				alt=""
				variants={
					noAnim
						? null
						: center
						? anim.bubble
						: top
						? anim.bubbleTop
						: anim.bubbleBottom
				}
				initial="initial"
				animate="animate"
				custom={{ scale, index }}
				className={`brand-bubble ${left ? "brand-bubble-left" : ""} ${
					right ? "brand-bubble-right" : ""
				} ${className}`}
				style={{
					zIndex: center ? 100 : zindex,
					transform: `scale(${scale})`,
					animationDelay: `${Math.random() * 6 + 2}s`,
					animationName: center ? "pulse" : "",
					animationDuration: center
						? "6s"
						: `${Math.random() * 6 + 4}s`,
				}}
				{...props}
			/>
		);
	}
);

export const BrandBubbles = memo(({ modalData, data, ...props }) => {
	return (
		<motion.section
			className="brand-bubble-container"
			{...props}
			variants={anim.bubbleContainer}
			initial="initial"
			animate="animate"
		>
			<div className="brand-bubble-pre">
				<BrandBubble
					dataArray={modalData.master_brands}
					index={4}
					top
				/>
				<div
					className="brand-bubble-center-row"
					style={{ transform: "translateY(-16px)" }}
				>
					<BrandBubble
						dataArray={modalData.master_brands}
						index={8}
						right
					/>
					<BrandBubble
						dataArray={modalData.master_brands}
						index={6}
					/>
				</div>
			</div>
			<div className="brand-bubble-center">
				<div className="brand-bubble-center-row">
					<BrandBubble
						dataArray={modalData.master_brands}
						index={2}
						zindex={1}
						scale={0.8}
						top
					/>
					<BrandBubble
						center
						imgSrc={data.publisher_details.logo_url}
						scale={1.6}
					/>
					<BrandBubble
						dataArray={modalData.master_brands}
						index={3}
						scale={0.8}
						top
					/>
				</div>
				<div
					className="brand-bubble-center-row"
					style={{ transform: "translateY(-20px)", zIndex: 2 }}
				>
					<BrandBubble
						dataArray={modalData.master_brands}
						index={0}
					/>
					<BrandBubble
						dataArray={modalData.master_brands}
						index={1}
					/>
				</div>
			</div>
			<div className="brand-bubble-post">
				<BrandBubble
					dataArray={modalData.master_brands}
					index={5}
					top
				/>
				<div
					className="brand-bubble-center-row"
					style={{ transform: "translateY(-16px)" }}
				>
					<BrandBubble
						dataArray={modalData.master_brands}
						index={7}
					/>
					<BrandBubble
						dataArray={modalData.master_brands}
						index={9}
						left
					/>
				</div>
			</div>
		</motion.section>
	);
});

export const BrandBubblesLinear = memo(({ modalData, data, ...props }) => {
	return (
		<section className="brand-bubble-linear-container" {...props}>
			<div className="brand-bubble-row">
				<BrandBubble
					dataArray={modalData.master_brands}
					index={2}
					top
					scale={0.8}
					zindex={10}
					noAnim
					className="brand-bubble-linear-edge"
				/>
				<BrandBubble
					dataArray={modalData.master_brands}
					index={1}
					top
					scale={1.2}
					zindex={11}
					noAnim
				/>
				<BrandBubble
					center
					imgSrc={data.publisher_details.logo_url}
					scale={1.6}
					zindex={1100}
					// center
					noAnim
				/>

				<BrandBubble
					dataArray={modalData.master_brands}
					index={0}
					scale={1.2}
					zindex={11}
					noAnim
					top
				/>
				<BrandBubble
					dataArray={modalData.master_brands}
					index={3}
					top
					scale={0.8}
					zindex={10}
					noAnim
					className="brand-bubble-linear-edge-right"
				/>
				<BrandBubble
					center
					imgSrc={data.publisher_details.logo_url}
					scale={1.6}
					zindex={1100}
					className="brand-bubble-linear-main"
					// center
					noAnim
				/>
			</div>
			<section className="brand-linear-body"></section>
		</section>
	);
});
